export default {
      id: "airport_shuttle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#airport_shuttle",
      toString: function () {
        return this.url;
      }
    }